import styled from '@emotion/styled';
import type { GridValidRowModel } from '@mui/x-data-grid/models/gridRows';

import { themeVars } from '../theme/theme';
import { Table } from './components/Table';
import type { FrontTableProps } from './helpers/types';
import { TableContext, TableStoreProvider } from './store/store';

export const FrontTable = <T extends GridValidRowModel = GridValidRowModel>(
  props: FrontTableProps<T>,
) => {
  return (
    <TableContext.Provider
      value={{
        perPageOptions: [10, 20, 50, 100],
        pageSize: 10,
        page: 0,
        headerHeight: 32,
        rowHeight: 42,
        rawDataProps: {},
        ...props,
      }}
    >
      <TableStoreProvider>
        <TableWrapper>
          {/*<TableActions />*/}
          <Table />
        </TableWrapper>
      </TableStoreProvider>
    </TableContext.Provider>
  );
};

const TableWrapper = styled.div`
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  border: 1px solid ${themeVars.colors.titan200};
`;
